<template>
  <div
    class="s-preloader"
    :style="`height: ${height}px`"
  >
    <preloader class="s-preloader__preloader"></preloader>
  </div>
</template>

<script>
  import Preloader from '~/assets/images/preloader.svg'

  export default {
    name: 'SPreloader',
    components: {
      Preloader
    },
    props: {
      height: {
        type: Number,
        default: 300
      }
    }
  }
</script>

<style lang="scss">
  .s-preloader {
    display: flex;
  }

  .s-preloader__preloader {
    width: 64px;
    height: 64px;
    max-width: 64px;
    max-height: 64px;
    margin: auto;
    animation: spin 2s infinite linear;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>